import { GameState, MatchState } from './Types';
export const getNewSingleGameFactory = (solutionWords) => {
    const getNewSingleGame = () => {
        const targetWord = solutionWords[Math.floor(Math.random() * solutionWords.length)];
        const rowCount = 8;
        const wordRows = [];
        for (let rowIdx = 0; rowIdx < rowCount; rowIdx++) {
            const wordRow = {
                letterBoxes: []
            };
            for (let i = 0; i < targetWord.length; i++) {
                wordRow.letterBoxes.push({
                    letter: '',
                    state: MatchState.normal,
                });
            }
            wordRows.push(wordRow);
        }
        return {
            targetWord,
            colCount: targetWord.length,
            rowCount,
            wordRows,
            currentGuess: '',
            currentGuessNumber: 0,
            state: GameState.playing,
        };
    };
    return getNewSingleGame;
};
export var SingleGameActionType;
(function (SingleGameActionType) {
    SingleGameActionType[SingleGameActionType["addLetter"] = 0] = "addLetter";
    SingleGameActionType[SingleGameActionType["deleteLetter"] = 1] = "deleteLetter";
    SingleGameActionType[SingleGameActionType["submitGuess"] = 2] = "submitGuess";
    SingleGameActionType[SingleGameActionType["new"] = 3] = "new";
    SingleGameActionType[SingleGameActionType["increaseGuessNumber"] = 4] = "increaseGuessNumber";
    SingleGameActionType[SingleGameActionType["initializeFromState"] = 5] = "initializeFromState";
})(SingleGameActionType || (SingleGameActionType = {}));
export const singleGameReducerFactory = (solutionWords, isWordValid) => {
    const singleGameReducer = (state, action) => {
        switch (action.type) {
            case SingleGameActionType.addLetter:
                if (state.state !== GameState.playing)
                    return state;
                const currentGuess = state.currentGuess.length < state.targetWord.length ?
                    state.currentGuess + action.payload.letter :
                    state.currentGuess;
                if (currentGuess !== state.currentGuess) {
                    const row = state.currentGuessNumber;
                    for (let i = 0; i < state.targetWord.length; i++) {
                        state.wordRows[row].letterBoxes[i].letter = '';
                        state.wordRows[row].letterBoxes[i].state = MatchState.normal;
                        if (i < currentGuess.length) {
                            state.wordRows[row].letterBoxes[i].letter = currentGuess.charAt(i);
                        }
                    }
                }
                return {
                    ...state,
                    currentGuess
                };
            case SingleGameActionType.deleteLetter:
                {
                    if (state.state !== GameState.playing) {
                        return state;
                    }
                    const currentGuess = state.currentGuess.length > 0 ?
                        state.currentGuess.slice(0, -1) :
                        state.currentGuess;
                    const row = state.currentGuessNumber;
                    for (let i = 0; i < state.targetWord.length; i++) {
                        state.wordRows[row].letterBoxes[i].letter = '';
                        state.wordRows[row].letterBoxes[i].state = MatchState.normal;
                        if (i < currentGuess.length) {
                            state.wordRows[row].letterBoxes[i].letter = currentGuess.charAt(i);
                        }
                    }
                    return {
                        ...state,
                        currentGuess
                    };
                }
            case SingleGameActionType.submitGuess:
                if (state.currentGuess.length === state.targetWord.length && state.state === GameState.playing) {
                    if (isWordValid(state.currentGuess)) {
                        const row = state.currentGuessNumber;
                        let allLettersMatch = true;
                        for (let i = 0; i < state.targetWord.length; i++) {
                            if (state.wordRows[row].letterBoxes[i].letter === state.targetWord.charAt(i)) {
                                state.wordRows[row].letterBoxes[i].state = MatchState.matches;
                            }
                            else if (state.targetWord.indexOf(state.wordRows[row].letterBoxes[i].letter) >= 0) {
                                state.wordRows[row].letterBoxes[i].state = MatchState.exists;
                                allLettersMatch = false;
                            }
                            else {
                                state.wordRows[row].letterBoxes[i].state = MatchState.nomatch;
                                allLettersMatch = false;
                            }
                        }
                        let newGameState = state.state;
                        if (allLettersMatch) {
                            newGameState = GameState.won;
                        }
                        else if (state.currentGuessNumber === state.rowCount - 1) {
                            newGameState = GameState.lost;
                        }
                        return {
                            ...state,
                            currentGuessNumber: state.currentGuessNumber + 1,
                            currentGuess: '',
                            state: newGameState,
                        };
                    }
                    else { // guess is not valid
                        const row = state.currentGuessNumber;
                        for (let i = 0; i < state.targetWord.length; i++) {
                            state.wordRows[row].letterBoxes[i].state = MatchState.invalidWord;
                        }
                        return {
                            ...state,
                        };
                    }
                }
                return state;
            case SingleGameActionType.new:
                return getNewSingleGameFactory(solutionWords)();
            case SingleGameActionType.increaseGuessNumber:
                if (state.state == GameState.playing) {
                    const row = state.currentGuessNumber;
                    let allLettersMatch = true;
                    for (let i = 0; i < state.targetWord.length; i++) {
                        if (state.wordRows[row].letterBoxes[i].letter === state.targetWord.charAt(i)) {
                            state.wordRows[row].letterBoxes[i].state = MatchState.matches;
                        }
                        else if (state.targetWord.indexOf(state.wordRows[row].letterBoxes[i].letter) >= 0) {
                            state.wordRows[row].letterBoxes[i].state = MatchState.exists;
                            allLettersMatch = false;
                        }
                        else {
                            state.wordRows[row].letterBoxes[i].state = MatchState.nomatch;
                            allLettersMatch = false;
                        }
                    }
                    let newGameState = state.state;
                    if (allLettersMatch) {
                        newGameState = GameState.won;
                    }
                    else if (state.currentGuessNumber === state.rowCount - 1) {
                        newGameState = GameState.lost;
                    }
                    return {
                        ...state,
                        currentGuessNumber: state.currentGuessNumber + 1,
                        currentGuess: '',
                        state: newGameState,
                    };
                }
                else {
                    return state;
                }
            case SingleGameActionType.initializeFromState:
                return { ...action.payload };
            default:
                throw Error('invalid action');
        }
    };
    return singleGameReducer;
};
